// extracted by mini-css-extract-plugin
export default {"paymentGroup":"AL7l9w","paymentGroupContainer":"TMDE98","paymentGroupContainerRow":"BD3AGc","paymentGroupContainerColumn":"_OEJnS","paymentGroupContainerWithoutBorder":"Bz55vm"};